import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import DescriptionIcon from '@material-ui/icons/DescriptionOutlined';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import pushToGTM, { CLICK_DATASHEET_GA4_TAG, CLICK_PRODUCT_PAGE_GA4_TAG } from '../../utils/analytics/gtm';
import { DIMENSIONS } from '../../styles/constants';
import { URL } from '../../utils/constants';
import { useStyles } from './styles';
import PdfExport from './PdfExport';
import DesignName from './DesignName';
import { logEventType, middlePartOfRedirectLink } from '../../utils/analytics/adobe/adob';
import queryString from 'query-string';
import Button from '../Button';

const SummaryActionbar = () => {
	const { t } = useTranslation();
	const classes = useStyles();
	const icPartNumber = useSelector(state => state.selectedDesign.icPartNumber);
	const datasheetUrl = useSelector(state => state.selectedDesign.detail.rankingParameters.datasheetUrl);
	const progressActive = useSelector(state => state.tabbar.progressActive);
	const inputParametersDL = useSelector(state => state.designList.inputParameters);
	const domain = window.location.origin;
	const fullURL = window.location.href;
	const path = window.location.pathname;

	const datasheetTrackingParameters = {
		redirectLink: datasheetUrl === '' ? URL.SALES_SUPPORT : datasheetUrl,
		partNumber: icPartNumber,
		inputParameters: JSON.stringify(inputParametersDL),
		buttonName: 'Datasheet',
		wdtTabName: 'summary',
		fullURL: fullURL,
		path: path,
		logEventType: logEventType.DATASHEETLOG
	};

	return (
		<Grid container justify="space-between" alignItems="center" spacing={2} className={classes.rootContainer}>
			<Grid item>
				{progressActive ? <Skeleton width={350} height={DIMENSIONS.SKELETON_TITLE_HEIGHT} /> : <DesignName />}
			</Grid>

			<Grid item container alignItems="center" className={classes.actionButtonsContainer}>
				<Grid item>
					{progressActive ? (
						<Skeleton
							variant="circle"
							width={DIMENSIONS.SKELETON_BUTTON_HEIGHT}
							height={DIMENSIONS.SKELETON_BUTTON_HEIGHT}
						/>
					) : (
						<Tooltip title={t('components.general.viewDatasheet')}>
							<div>
								<Button
									variant="contained"
									color="primary"
									href={domain + middlePartOfRedirectLink + queryString.stringify(datasheetTrackingParameters)}
									style={{ display: 'flex', alignItems: 'center' }}
									target="_blank"
									onClick={() => {
										pushToGTM(CLICK_DATASHEET_GA4_TAG);
									}}
									rel="noopener noreferrer"
									endIcon={<DescriptionIcon />}>
									<Typography style={{ fontWeight: 600 }}>{t('components.general.datasheet')}</Typography>
								</Button>
							</div>
						</Tooltip>
					)}
				</Grid>

				<Grid item>
					{progressActive ? (
						<Skeleton
							variant="circle"
							width={DIMENSIONS.SKELETON_BUTTON_HEIGHT}
							height={DIMENSIONS.SKELETON_BUTTON_HEIGHT}
						/>
					) : (
						<Tooltip title={t('components.general.viewProductsDetails')}>
							<div>
								<Link
									href={URL.PRODUCT_PAGE_PREFIX + icPartNumber}
									target="_blank"
									onClick={() => {
										pushToGTM(CLICK_PRODUCT_PAGE_GA4_TAG);
									}}
									rel="noopener noreferrer">
									<IconButton aria-label="View Product Details" disabled={progressActive}>
										<OpenInNewIcon />
									</IconButton>
								</Link>
							</div>
						</Tooltip>
					)}
				</Grid>

				<Grid item>
					{progressActive ? (
						<Skeleton width={DIMENSIONS.SKELETON_BUTTON_WIDTH} height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} />
					) : (
						<PdfExport />
					)}
				</Grid>
			</Grid>
		</Grid>
	);
};

export default SummaryActionbar;
